export default "__VITE_ASSET__8cb610e7__"